import { Link } from "react-router-dom";
import { Sigle, deNom, useBranding } from "../../branding";
import { useLiensTransition } from "../../motion";
import { ROUTES } from "../../shell";
import styles from "./Vitrine.module.css";

/** Le pied de la vitrine : la marque et les deux portes, une fois de plus. */
export function VitrinePied() {
  const lien = useLiensTransition();
  const { esn_name, product_name } = useBranding();
  return (
    <footer className={styles.pied}>
      <div className={styles.piedMarque}>
        <Sigle className={styles.sigle} />
        <span>
          <strong>{product_name}</strong>
          <br />
          La plateforme {deNom(esn_name)} : crédits prépayés, projets et feuilles de temps, sur un grand livre en ajout seul.
        </span>
      </div>
      <nav className={styles.piedLiens} aria-label="Pied de page">
        <Link to={ROUTES.connexion} {...lien(ROUTES.connexion, "cube-avant")}>Se connecter</Link>
        <Link to={ROUTES.inscription} {...lien(ROUTES.inscription, "cube-avant")}>Inscription</Link>
      </nav>
      <p className={styles.piedMention}>
        © {new Date().getFullYear()} {esn_name}
      </p>
    </footer>
  );
}
